<template>
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Workshift Color</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text dense>
            <v-layout row wrap class="border">
                <p v-if="error" style="color:red;">{{ errorMessage }}</p>
                <v-flex xs12 sm12>
                    <div class="color-group-container">
                        <span>Select color group</span>
                        <div v-for="(item, index) in colorGroups" :key="index">
                            <div class="color-div" :title="item.description" @click="displayColorList(item.name)" :style="`background-color:${item.hex}`"></div>
                        </div><br><br>
                        <span>Then select color name</span>
                        <div v-for="(item, index) in colorList" :key="index">
                            <div class="color-div" :title="item.description" @click="selectColor(item.hex)" :style="`background-color:${item.hex}`"></div>
                        </div>
                    </div>
                </v-flex>  
            </v-layout> 
        </v-card-text>
    </v-card>
</template>
<script>

import colorsApi from '@/api/colors'

export default {
    data() {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            colors: [],
            colorName: null,
        }
    },
    methods: {
        async getColors() {
            try {
                this.loading = true
                const response = await colorsApi.getForWorkShifts()
                if (response && response.status == 200) {
                    this.colors = response.data.colors
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        selectColor(hex) {
            this.$emit('send', hex)
            this.closeDialog()
        },
        displayColorList(name) {
            this.colorName = name
        },
        closeDialog() {
            this.$emit('update:dialogColorPicker', false)
        }
    },
    created() {
        this.getColors()
    },
    computed: {
        colorGroups() {
            if (!this.loading) {
                return this.colors
                    .filter(x => x.shadeType == 0)
                    .map(x => {
                        return {
                            name: x.name,
                            hex: x.hex
                        }
                    })
            }
        },
        colorList() {
            const filter = this.colorName ? this.colorName : 'red';
            return this.colors
                    .filter(x => x.name == filter)
                    .sort((a, b) => a.description.localeCompare(b.description))
                    .map(x => {
                        return {
                            description: x.description,
                            hex: x.hex
                        }
                    });
        }
    },
}
</script>
<style scoped>
.border {
    padding: 0px 10px 10px 10px;
}
.color-group-container {
    margin: 0px 20px 20px 10px;
}
.color-group {
    width: 100%;
    border: 1px solid transparent;
}
.container {
  width: 100%; 
  overflow: hidden;
}
.color-div {
  width: 35px;
  height: 35px;
  margin: 1px;
  float: left;
  box-sizing: border-box; 
  cursor: pointer;
}
.container::after {
  content: "";
  display: table;
  clear: both;
}
</style>
